export enum Status {
  PENDING = "Pending",
  PROCESSING = "Processing",
  COMPLETE = "Complete",
  FAILED = "Failed",
  // CANCELLED = 'Cancelled'
}

/** Returned when creating a new task */
export interface TaskResponse {
  taskId: string;
}

export enum TaskType {
  SOURCE_DOWNLOAD = "downloadSource",
  SOURCE_REFINE = "createCorpus",
  CORPUS_DERIVE = "deriveCorpus",
  CORPUS_DOWNLOAD = "downloadCorpus",
  TRANSFORM_CREATE = "createTransform",
  TRANSFORM_REMOVE = "removeTransform",
  TRANSFORM_UPDATE = "updateTransform",
  PIF_DOWNLOAD = "downloadPif",
  SEND_PIF_TO_CORE = "startTraining",
  SEND_PIF_TO_EXPLORE = "uploadExplore",
  SEND_PIF_TO_DASHBOARD = "dashboard",
}

export interface StatusResponse {
  taskId: string;
  type: string;
  entityId: number;
  status: Status;
  details?: any;
}

export const isFinished = (sr: StatusResponse) => sr.status === Status.COMPLETE || sr.status === Status.FAILED;
export const isTransform = (sr: StatusResponse) =>
  sr.type === TaskType.TRANSFORM_CREATE ||
  sr.type === TaskType.TRANSFORM_UPDATE ||
  sr.type === TaskType.TRANSFORM_REMOVE;
